import uiRouter from 'angular-ui-router';

import authDashboardTpl from './views/authDashboard.html';
import authDashboardCtrl from './controllers/authDashboardController';
import authSidenavTpl from './views/authSidenav.html';
import authSidenavCtrl from './controllers/authSidenavController';
import authOverviewTpl from './views/authOverview.html';
import authOverviewCtrl from './controllers/authOverviewController';
import themeSummaryTpl from './views/themeSummary.html';
import themeSummaryCtrl from './controllers/themeSummaryController';
import subjectStudentTpl from './views/subjectStudentListing.html';
import subjectStudentCtrl from './controllers/subjectStudentListing';
import subjectReportTpl from './views/subjectReport.html';
import subjectReportCtrl from './controllers/subjectReport';

import './authDashboard.scss';
import _ from "underscore";

//Courseware module
var module = angular.module('app.AuthDashboardModule', [
        uiRouter,
    ]).component("authsidenav", {
        template: authSidenavTpl,
        controllerAs: "authsidenav",
        controller: authSidenavCtrl
    })
    .controller('authSidenavCtrl', authSidenavCtrl)
    .controller('authDashboardCtrl', authDashboardCtrl)
    .controller('authOverviewCtrl', authOverviewCtrl)
    .controller('themeSummaryCtrl', themeSummaryCtrl)
    .controller('subjectStudentCtrl', subjectStudentCtrl)
    .controller('subjectReportCtrl', subjectReportCtrl)


module.constant('AUTHDASHCONSTANT', {
        AUTH_DASH_URL: "/v0/auth-dashboard/get-details",
        API_AUTH_DASH_OVERVIEW_URL: "/v0/auth-dashboard/overview/get-syllabus",
        API_THEME_SUMMARY_URL: "/v0/theme/summary/teachingplan",
        //Status for teaching plan and resources
        STATUS_CREATED: "created",
        STATUS_DRAFT: "draft",
        STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
        STATUS_APPROVED: "approved",
        STATUS_REJECTED: "rejected",
        STATUS_CONDUCTED: "conducted",
        API_SUBJECT_REPORT:"/v0/subject-report",
        API_GET_STUDENT_EMAILS: '/v0/auth-dashboard/student/emails'
    })
//Sidenav module
   /* var authSidenavmodule = angular.module('AuthSidenavModule', [
        uiRouter
        //import modules
    ]).component("authsidenav", {
        template: authSidenavTpl,
        controllerAs: "authsidenav",
        controller: authSidenavCtrl
    });*/
    module.constant('AUTHSIDENAVCONSTANT', {
        API_AUTH_SIDENAV_URL: "/v0/auth-dashboard/side-nav/tp-list"
    })
   /* module.config(function($stateProvider) {
        "ngInject";

        $stateProvider
            .state('authsidenav', {
                parent: 'app',
                url: '/authDashboard',
                views: {
                    '@': {
                        template: authSidenavTpl,
                        controller: authSidenavCtrl,
                        controllerAs: 'authsidenav'
                    }
                }
            })
    });*/
    /*module.config(function($stateProvider) {
        "ngInject";

        $stateProvider
            .state('authdashboard', {
                parent: 'app',
                url: '/authDashboard',
                views: {
                    '@': {
                        template: authDashboardTpl,
                        controller: authDashboardCtrl,
                        controllerAs: 'authDashboard'
                    }
                }
            })
    });

    //Sidenav module
    var authSidenavmodule = angular.module('AuthSidenavModule', [
        uiRouter
        //import modules
    ]).component("authsidenav", {
        template: authSidenavTpl,
        controllerAs: "authsidenav",
        controller: authSidenavCtrl
    });
    authSidenavmodule.constant('AUTHSIDENAVCONSTANT', {
        API_AUTH_SIDENAV_URL: "/v0/auth-dashboard/side-nav/tp-list"
    })
    authSidenavmodule.config(function($stateProvider) {
        "ngInject";

        $stateProvider
            .state('authsidenav', {
                parent: 'app',
                url: '/authDashboard',
                views: {
                    '@': {
                        template: authSidenavTpl,
                        controller: authSidenavCtrl,
                        controllerAs: 'authsidenav'
                    }
                }
            })
    });

    //Overview module
    var authOverviewmodule = angular.module('AuthOverviewModule', [
        uiRouter
        //import modules
    ]);
    authOverviewmodule.config(function($stateProvider) {
        "ngInject";

        $stateProvider
            .state('authoringTool', {
                parent: 'app',
                url: '/authoring-tool',
                views: {
                    '@': {
                        template: authOverviewTpl,
                        controller: authOverviewCtrl,
                        controllerAs: 'authoringTool'
                    }
                }
            })
    });
    //Theme summary module
    var themeSummaryModule = angular.module('ThemeSummaryModule', [
        uiRouter
        //import modules
    ]);
    themeSummaryModule.config(function($stateProvider) {
        "ngInject";

        $stateProvider
            .state('theme-summary', {
                parent: 'app',
                url: '/theme-summary/:theme_id',
                views: {
                    '@': {
                        template: themeSummaryTpl,
                        controller: themeSummaryCtrl,
                        controllerAs: 'themeSummary'
                    }
                }
            })
    });*/

module.config(function($stateProvider, $locationProvider) {
    "ngInject";
});

export default module;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/authToolModule.js